import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, UntypedFormGroup, Validators } from '@angular/forms';
import { BaseComponent } from '@app/base/basecomponent';
import { Router } from '@angular/router';
import { BsDropdownDirective } from 'ngx-bootstrap/dropdown';
import { AuthenticationService } from '@app/_services/authentication.service';
import { TenantDetail } from '@app/_models/organization/organization';
import { PersistenceService } from '@app/_services/persistence.service';
import { UserSettingLink } from '@app/_models/settings/user-settings';
import { UserLanguage } from '@app/_enums/userLanguage';
import { UserSettingService } from '@app/areas/usersetting/usersetting.service';
import { UserService } from "@app/areas/user/user.service";
import { Store } from '@ngxs/store';

@Component({
  selector: 'tenant-select-dropmenu',
  templateUrl: './tenant-select-dropmenu.component.html',
  styleUrls: ['./tenant-select-dropmenu.component.scss']
})
export class TenantSelectDropMenuComponent extends BaseComponent implements OnInit {

  public currentTenant: any;
  public tenants: TenantDetail[] = [];
  public filteredTenants: TenantDetail[];
  public form: UntypedFormGroup;

  public loading: boolean = true;

  constructor(
    private userService: UserService,
    private persistence: PersistenceService,
    private userSettingService: UserSettingService,
    private router: Router,
    private store: Store
  ) {
    super();
  }

  ngOnInit(): void {
    this.getData();
    this.form = this.formBuilder.group({
      search: ['']
    });
    this.form.get('search').valueChanges.subscribe(value => {
      this.filteredTenants = (this.tenants ?? []).filter(tenant => {
        return tenant.name?.toLowerCase()?.includes((value ?? '').toLowerCase());
      });
    });
  }

  getData() {
    this.subscription.add(
    this.userService.getUserTenants().subscribe(result => {
      this.tenants = result;
      this.filteredTenants = this.tenants;
      this.currentTenant = this.tenants.find(x => x.id == this.authService.currentUserValue.tenantId);
      this.loading = false;
    }, error => {
      this.errorHandler.applyGeneralErrors(error);
      this.loading = false;
    }));
  }

  chooseTenant(tenantId: number) {
    this.subscription.add(
      this.authService.switchTenant(tenantId).subscribe(data => {
        // When this local storage item is set, local storage items should be refreshed.
        this.persistence.set('avux-req-init', 1);

        // Change language if it differs from current language. Note that it is also possible to simply call POST request to
        // change it even when it has not been changed.
        const currentLang = localStorage.getItem('l-curLang');
        if(currentLang){
          let langSettings: UserSettingLink[] = [{
            userAccountId: this.authService.currentUserValue.id,
            userSettingId: "userLanguage",
            currentVal: UserLanguage[currentLang]
          }];

          this.userSettingService.setUserSettings(langSettings).subscribe();
        }


        this.router.navigate(['/']).then(() => {
          location.reload();
        });
      }, error => {
        this.alertService.error(error);
      })
    );
  }
}
